import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

interface IConsultationStatus {
    teleconsultation_id: string;
    status: "pending" | "ongoing" | "ended";
    maxDuration: string;
    callType: string;
    reminder: number;
}

const initialState = {} as IConsultationStatus;

const teleconsultationSlice = createSlice({
    name: "teleconsultation",
    initialState,
    reducers: {
        setTeleconsultation: (state, action: PayloadAction<IConsultationStatus>) => {
            Object.assign(state, action.payload);
        },
        setTeleconsultationStatus: (state, action) => {
            state.status = action.payload;
        },
        setMaxDuration: (state, action) => {
            state.maxDuration = action.payload;
        },
        setReminder: (state, action) => {
            state.reminder = action.payload;
        }
    },
});

export const { setTeleconsultation, setTeleconsultationStatus, setMaxDuration, setReminder } = teleconsultationSlice.actions;
export default teleconsultationSlice.reducer;

export const getTeleconsultation = (state: RootState) => state.consultation;
